import type { TOC } from '@ember/component/template-only'
import UiButtonLink from 'teacher-ui-client/components/ui-button/link'
import { t } from 'ember-intl'
import { pdfDownloadEvent } from 'teacher-ui-client/modifiers/pdf-download-event'
import { ButtonAppearance } from 'teacher-ui-client/components/ui-button/themes'

interface Signature {
  Element: HTMLDivElement
  Args: {
    coverUrl: string
    title: string
    description?: string
    fileUrl: string
  }
}

export const CaseStudyTile: TOC<Signature> = <template>
  <div class="sm:w-full md:w-1/2 lg:w-1/3 xl:w-1/4 2xl:w-1/5" data-test-case-study-resource="true">
    <div class="mx-6 mt-6 block rounded-b-md border-2 px-6 py-6" ...attributes>
      <img
        src="{{@coverUrl}}?h=250"
        class="border-dusty-black-100 mx-auto block w-1/2 rounded-md border border-solid p-1 shadow-xs"
        alt="{{@title}}"
      />
      <h5 class="mt-4 mb-4 text-center">
        {{@title}}
      </h5>
      {{#if @description}}
        <div class="mb-4 text-center">{{@description}}</div>
      {{/if}}
      <div class="text-center">
        <UiButtonLink
          href={{@fileUrl}}
          target="_blank"
          rel="noopener noreferrer"
          @appearance={{ButtonAppearance.regular}}
          {{pdfDownloadEvent category="Case Study PDF" label=@title}}
        >
          {{t "download"}}
        </UiButtonLink>
      </div>
    </div>
  </div>
</template>

export default CaseStudyTile
